import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';

export interface ChoiceDialogParams {
  title: string;
  description: string;
  options: ChoiceDialogOptions[];
}

interface ChoiceDialogOptions {
  text: string;
  action: Function;
}

@Component({
  templateUrl: './fc-choice-dialog.component.html',
  styleUrls: ['./fc-choice-dialog.component.scss']
})

export class FcChoiceDialogComponent {
  public selected: Function = null;

  constructor(
    private fuseTranslationLoaderService: FuseTranslationLoaderService,
    private dialogRef: MatDialogRef<FcChoiceDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ChoiceDialogParams
  ) {
    this.fuseTranslationLoaderService.loadJsonTranslations({ english, portuguese, spanish });
  }

  public async confirm(): Promise<void> {
    await this.selected();
    this.dialogRef.close('confirm');
  }

  public close(): void {
    this.dialogRef.close('close');
  }

}
